import React from 'react';

export const Arrow = ({ stroke = '#10387F', rotate = 0 }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      style={{
        transformBox: 'fill-box',
        transformOrigin: 'center',
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <path d='M9 18.5L15 12.5L9 6.5' stroke={stroke} strokeWidth='2' />
    </svg>
  );
};
